import React, { useContext, useMemo, useState } from 'react';
import styled from 'styled-components';
import { Modal as BaseModal } from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { OrdersSummaryTable } from '../OrdersSummaryTable';
import OrdersSummaryModalTabs from './OrdersSummaryModalTabs';
import { ORDER_SUMMARY_TABS } from './constants';

const Modal = styled(BaseModal)`
  .content {
    height: 90vh;
    padding: 10px 32px;
  }
  .buttons {
    padding: 10px;
    border-top: 1px solid ${({ theme }) => theme.colors.grey2};
    background: ${({ theme }) => theme.colors.white};
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
  }
  .data-grid {
    height: 100%;
  }
`;

const OrdersSummaryModal = ({ onClose, orders, showBranch = false, stats }) => {
  const { t } = useContext(ConfigContext);
  const [activeTab, setActiveTab] = useState(ORDER_SUMMARY_TABS.ACTIVE);

  const data = useMemo(
    () =>
      (orders || []).map(
        ({
          id,
          supplierBranchId,
          clientBranchId,
          project: { date, name, id: projectId, needed },
          status,
          isPast,
          createdAt
        }) => ({
          id,
          date,
          projectId,
          clientBranchId,
          name,
          status,
          createdAt,
          needed,
          supplierBranchId,
          isPast
        })
      ),
    [orders]
  );

  const filteredData = useMemo(
    () => (data || []).filter(({ isPast }) => (activeTab === ORDER_SUMMARY_TABS.ACTIVE ? !isPast : !!isPast)),
    [activeTab, data]
  );

  return (
    <Modal size="large" title={t('pendingOrdersSummary')} onClose={onClose} showConfirmButton={false}>
      <OrdersSummaryModalTabs activeTab={activeTab} setActiveTab={setActiveTab} stats={stats} />
      <OrdersSummaryTable data={filteredData} showBranch={showBranch} />
    </Modal>
  );
};

export default OrdersSummaryModal;
